import script from "./SearchPageSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchBar.vue?vue&type=style&index=0&id=b0b7d996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0b7d996"]])

export default __exports__